module.exports = __webpack_public_path__ + "static/media/ic-refresh-grey.85537213.svg";